import * as React from 'react';
import AgentSkillDetailComponent from './AgentSkillDetailComponent';
import { Card, CardHeader, CardTitle } from '../../../../ui/card';
import { useContext } from 'react';
import { AgentSetupContext } from '../../AgentSetupComponent';
import { useTranslate } from 'sbx-crm-menu-ui';
import { AgentSkills } from '../../../../../types/AiAgentV2';

type Props = {
    removeSkill: (skill_id: number, skill: AgentSkills, index: number) => void;
    fields: any[];
    updateSkill: (skill: AgentSkills, skill_index: number) => void;
};
const AgentSkillListComponent = ({ removeSkill, fields, updateSkill }: Props) => {
    const {
        skillsForm: skillsSetupForm,
    } = useContext(AgentSetupContext);

    const { t: agent } = useTranslate('agent');
    // console.log(skillsSetupForm);
    // console.log(fields);
    return (
        <div className="container mx-auto px-4 pb-8  flex flex-col gap-2 max-h-[85vh] overflow-auto">
            {fields.length > 0 ? (
                <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
                    {agent('new_skills')}
                </h2>
            ) : null}
            {fields.length > 0 ? (
                <div className="grid grid-cols-1  gap-6">
                    {fields.map((field, index) => (
                        <AgentSkillDetailComponent
                            isNew
                            skill={field}
                            updateSkill={() => {
                                updateSkill(field, index);
                            }}
                            removeSkill={() => {
                                removeSkill(field.id, field, index);
                            }}
                            key={field.id}
                        />
                    ))}
                </div>
            ) : null}

            {skillsSetupForm.fields.length > 0 ? (
                <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
                    {agent('skills')}
                </h2>
            ) : null}

            <div className="grid grid-cols-1  gap-6">
                {skillsSetupForm.fields.length > 0 ? (
                    skillsSetupForm.fields.map((field, index) => (
                        <AgentSkillDetailComponent
                            skill={field}
                            updateSkill={() => {
                                updateSkill(field, index);
                            }}
                            removeSkill={() => {
                                if (field.skill_id) {
                                    removeSkill(field.skill_id, field, index);
                                }
                            }}
                            key={field.id}
                        />
                    ))
                ) : fields.length === 0 ? (
                    <Card className="flex flex-col bg-gradient-to-br from-blue-100 to-purple-100 hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                        <CardHeader>
                            <CardTitle className="flex items-center justify-between">
                                <span className="flex justify-between items-center text-xl font-bold text-indigo-800">
                                    {agent('no_skills_available')}
                                </span>
                            </CardTitle>
                        </CardHeader>
                    </Card>
                ) : null}
            </div>
        </div>
    );
};

export default AgentSkillListComponent;
